import { render, staticRenderFns } from "./VendorAddress.vue?vue&type=template&id=175ecd02"
import script from "./VendorAddress.vue?vue&type=script&lang=js"
export * from "./VendorAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175ecd02')) {
      api.createRecord('175ecd02', component.options)
    } else {
      api.reload('175ecd02', component.options)
    }
    module.hot.accept("./VendorAddress.vue?vue&type=template&id=175ecd02", function () {
      api.rerender('175ecd02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorAddress.vue"
export default component.exports